export default __webpack_public_path__ + "assets/images/174399e181a7207f5db410993b600ecb.png";